<app-navbar></app-navbar>
<app-sidenav>
    works
</app-sidenav>